import templateUrl from 'emun.swatch/swatchlist-prompt.htm'
import SwatchCountPromptController from 'emun.swatch/swatchlist-prompt.controller'
import resolve from 'ioc/resolve'
import modals from 'webmodals/modals'

const SwatchListPrompt = {
    open(options) {
        return modals.open(angular.extend({
            size: 'lg',
            // placement: 'right',
            //backdrop: false,
            templateUrl,
            resolve: {
                options: () => options
            },
            bindToController: true,
            controller: SwatchCountPromptController,
            controllerAs: '$ctrl'
        }, (options || {}).modal)).result;
    }
};

export default SwatchListPrompt;